export default "__VITE_ASSET__DXg0o5kG__"